import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { CONSTANTS } from '../../../constants/constants';
const valuesToAvoid = ['kernel', 'os'];
import NRShortenFilePath from './NRShortenFilePath/NRShortenFilePath';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeTabAndSubTabFromFilePath } from '../../../services/urlInterceptor.utils';

const FilePathFormatter = ({ value }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClick = () => {
    let extraParams = new URLSearchParams();
    extraParams.append('filePath', value);
    navigate(`${removeTabAndSubTabFromFilePath(location)}/${CONSTANTS.REPORT.TABS.FILE_SYSTEM}?${extraParams.toString()}`);
  };

  const shouldDisplayLink = !!value && valuesToAvoid.every(valueToAvoid => valueToAvoid !== value);

  return value != null ? (
    <NRShortenFilePath filePath={value} shouldDisplayLink={shouldDisplayLink} onClickLink={handleOnClick} customMinWidth={150} />
  ) : (
    <span>{'-'}</span>
  );
};
export const FilePathProvider = props => <DataTypeProvider formatterComponent={FilePathFormatter} {...props} />;
